import { LiveAnnouncer } from '@angular/cdk/a11y';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatChipInputEvent, MatChipGrid, MatChipRow, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { ActivatedRoute, Router } from '@angular/router';
import { map, Observable, startWith, Subject, takeUntil } from 'rxjs';
import { ApprovalDetail } from 'src/app/models/interface/CAM/approval-management';
import { CamService } from 'src/app/services/camService/cam.service';
import { ApprovalManagementService } from 'src/app/services/dataLayer/CAM/approval-management.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { ApprovalContentService } from '../../services/approval-content.service';
import { WaitingComponent } from '../../../../shared/components/waiting/waiting.component';
import { NgIf, NgFor, NgStyle, AsyncPipe } from '@angular/common';
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSelect } from '@angular/material/select';
import { MatOption, MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';

@Component({
    selector: 'app-workflowsetting-form',
    templateUrl: './workflowsetting-form.component.html',
    styleUrls: ['./workflowsetting-form.component.scss'],
    imports: [WaitingComponent, NgIf, ReactiveFormsModule, MatFormField, MatLabel, MatIcon, MatSuffix, MatSelect, NgFor, MatOption, MatError, MatChipGrid, MatChipRow, MatChipRemove, MatChipInput, MatAutocompleteTrigger, NgStyle, MatAutocomplete, MatCheckbox, MatButton, AsyncPipe]
})
export class WorkflowsettingFormComponent implements OnInit, OnDestroy {
  allCorporateUsersList: any;
  workFlowSettingForm!: FormGroup;
  receivedData: any;
  productList: any;
  appliedOnList: any;
  travellerCategory: any;
  RuleAppliedForDataList: any;
  workFlowId: any;
  appliedOnName: any;
  ruleAppliedName: any;
  isLoading: boolean = false;
  commonObjPipes: any = {
    GetAllTravelerCategory: { pipe: [], all: [] },

  }

  //chips dropdown
  separatorKeysCodes: number[] = [ENTER, COMMA];
  appliedForID = new FormControl('');
  filteredAssocatedWithRule: Observable<any[]>;
  associateRuleName: string[] = [];
  selectedAssoicatedRuleIdMap: { [key: number]: boolean } = {};
  noRecordFound: boolean = false;
  approvalList: any;
  @ViewChild('resultsWaiting') resultsWaiting!: TemplateRef<any>;
  @ViewChild('fruitInput') fruitInput!: ElementRef<HTMLInputElement>;

  announcer = inject(LiveAnnouncer);
  private destroy$ = new Subject<void>();
  content:any;
  dictionaryContent:any;
  constructor(private router: Router, private _ActivatedRoute: ActivatedRoute, private _CamService: CamService, private fb: FormBuilder, private _ToastrApiService: ToastrApiService, private _CompanyManagementService: CompanyManagementService, private _ApprovalManagementService: ApprovalManagementService,private contentService:ApprovalContentService,private readonly dictionaryContentService: DisctionaryContent) {


    this.workFlowSettingForm = this.fb.group({
      productType: ['', [Validators.required]],
      travelCategory: ['', [Validators.required]],
      workFlowAppliedOn: ['', [Validators.required]],
      appliedForID: ['', [Validators.required]],

      approvalFlow: ['EIT'],//approval-flow-form controller
      totalApprovals: [3],
      inPolicyApproverIDL1: [null],
      inPolicyApproverIDL2: [null],
      inPolicyApproverIDL3: [null],
      outPolicyApproverIDL1: [null],
      outPolicyApproverIDL2: [null],
      outPolicyApprover_DL3: [null],
      flag: ['ADD'],
      workFlowID: [null]
    })


    this.filteredAssocatedWithRule = this.appliedForID.valueChanges.pipe(
      startWith(null),
      map((value: string | null) => {
        if (typeof value === 'string') {
          return this._filter(value);
        } else {
          return this.RuleAppliedForDataList?.slice();
        }
      })
    );

  }

  ngOnInit(): void {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.content = res;
    })
     this.dictionaryContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
          this.dictionaryContent = res;
    })
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.workFlowId = this._ActivatedRoute.snapshot.paramMap.get('id');

    this.loadInitialData().then(() => {
      if (this.workFlowId) {
        if (this._CamService.approvalWorkFlowSettingFormData && this._CamService.approvalWorkFlowSettingFormData.form?.workFlowID == this.workFlowId) {
          this.patchSavedWorkflowSetting();
        } else {
          this.editPatchWorkflowSetting();
        }
      } else if (this._CamService.approvalWorkFlowSettingFormData) {
        this.patchSavedWorkflowSetting();
      }
    });
    //GTM use
    this._ApprovalManagementService.$approvalList.subscribe((result) => {
      this.approvalList = result
    })

    this._ApprovalManagementService.page_landing(' Approval Management - Workflow settings', this.approvalList?.length, 'Approval Management Workflow') //GTM use


  }

  async loadInitialData() {
    try {
      this.isLoading = true;

      const [product, travelCat, ruleAppliedOn] = await Promise.all([
        this._CamService.getProductList(),
        this._CamService.getTravelCategory(),
        this._CamService.getRulesAppliedOn()
      ]);

      this.productList = product?.data;
      this.travellerCategory = travelCat?.data;
      this.appliedOnList = ruleAppliedOn?.data;

    } catch (error: any) {
      console.log(error);
      const errMsg =
        error?.message ||
        error?.error?.message ||
        'Something went wrong while fetching Data.';

      this._ToastrApiService.show('error', errMsg);
    } finally {
      this.isLoading = false; // always turn off loader
    }
  }



  editPatchWorkflowSetting(): Promise<void> {

    return new Promise((resolve, reject) => {
      if (!this.workFlowId) {
        return resolve();
      }
      this.isLoading = true;
      this._CamService.getApprovalManagementByIdV1(this.workFlowId).then((res) => {
        console.log(res)
        if (res?.data?.length) {
          const editValue: ApprovalDetail = res.data[0];
          this.allCorporateUsersList = res.data[0]// sending to other component
          const appliedForArray = editValue.appliedForId ? editValue.appliedForId.split(',').map((id: any) => parseInt(id)) : [];
          // Initialize selectedAssoicatedRuleIdMap and associateRuleName
          this.selectedAssoicatedRuleIdMap = {};
          this.associateRuleName = [];

          // After RuleAppliedForDataList is loaded, process the appliedForArray
          this.appliedOnSelectionChange(Number(editValue.workflowType)).then(() => {

            if (this.RuleAppliedForDataList) {
              appliedForArray.forEach((id: any) => {
                const rule = this.RuleAppliedForDataList.find((r: any) => r.id === id);
                if (rule && !this.associateRuleName.includes(rule.name)) { // Check if rule.Name is already present
                  this.selectedAssoicatedRuleIdMap[id] = true;
                  this.associateRuleName.push(this.getDisplayName(rule));
                }
              });
            }

            // Patch form values
            this.workFlowSettingForm.patchValue({
              productType: editValue?.productType,
              travelCategory: Number(editValue?.travelCategory),
              workFlowAppliedOn: Number(editValue?.workflowType),
              appliedForID: editValue?.appliedForId,

              //approval-flow-form
              flag: 'UPDATE',
              workFlowID: this.workFlowId,
              approvalFlow: editValue?.approvalFlow,//approval-flow-form controller
              totalApprovals: Number(editValue?.workflowRule),
              inPolicyApproverIDL1: editValue?.inPolicyApproverIdL1,
              inPolicyApproverIDL2: editValue?.inPolicyApproverIdL2,
              inPolicyApproverIDL3: editValue?.inPolicyApproverIdL3,
              outPolicyApproverIDL1: editValue?.outPolicyApproverIdL1,
              outPolicyApproverIDL2: editValue?.outPolicyApproverIdL2,
              outPolicyApprover_DL3: editValue?.outPolicyApproverIdL3

            });

            resolve();
          })
            .catch((error) => {
              console.error("Error in appliedOnSelectionChange:", error);
              reject(error);
            });

        } else {
          console.warn("No data received for workFlowId:", this.workFlowId);
          resolve();  // Ensure the promise is resolved even if no data is found
        }
      })
        .catch((error) => {
          console.error("Error fetching workflow settings:", error);
          reject(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    });
  }

  patchSavedWorkflowSetting(): Promise<void> {
    return new Promise((resolve, reject) => {
      const savedData = this._CamService.approvalWorkFlowSettingFormData;
      if (!savedData || !savedData.form) {
        return resolve();
      }
      this.isLoading = true;
      const formVal = savedData.form;
      this.allCorporateUsersList = savedData.lists;
      const appliedForStr = formVal.appliedForID || formVal.appliedForId || '';
      const appliedForArray = appliedForStr ? String(appliedForStr).split(',').map((id: any) => parseInt(id)) : [];
      this.selectedAssoicatedRuleIdMap = {};
      this.associateRuleName = [];

      this.appliedOnSelectionChange(Number(formVal.workFlowAppliedOn)).then(() => {
        if (this.RuleAppliedForDataList) {
          appliedForArray.forEach((id: any) => {
            const rule = this.RuleAppliedForDataList.find((r: any) => r.id === id);
            if (rule) {
              const displayName = this.getDisplayName(rule);
              if (!this.associateRuleName.includes(displayName)) {
                this.selectedAssoicatedRuleIdMap[id] = true;
                this.associateRuleName.push(displayName);
              }
            }
          });
        }

        this.workFlowSettingForm.patchValue({
          ...formVal,
          travelCategory: formVal?.travelCategory !== undefined && formVal?.travelCategory !== null && formVal?.travelCategory !== '' ? Number(formVal.travelCategory) : formVal?.travelCategory,
          workFlowAppliedOn: formVal?.workFlowAppliedOn !== undefined && formVal?.workFlowAppliedOn !== null && formVal?.workFlowAppliedOn !== '' ? Number(formVal.workFlowAppliedOn) : formVal?.workFlowAppliedOn,
          appliedForID: formVal?.appliedForID || formVal?.appliedForId || ''
        });
        resolve();
      }).catch((error) => {
        console.error("Error in patchSavedWorkflowSetting:", error);
        reject(error);
      }).finally(() => {
        this.isLoading = false;
      });
    });
  }




  bindLists(key: string, lists: any[]) {
    this.commonObjPipes[key].pipe = lists;
    this.commonObjPipes[key].all = lists;
  }



  async onContinue() {
    const formValue = this.workFlowSettingForm.value;
    const ruleAppliedOn = formValue.workFlowAppliedOn;
    const ruleAppliedFor = formValue.appliedForID;
    const travelCategory = formValue.travelCategory;
    const uid = formValue.workFlowID || '455646546465';

    try {
      if (formValue.flag !== 'UPDATE') {
        await this._CamService.checkDuplicateApprovalWorkflow(ruleAppliedOn, ruleAppliedFor, travelCategory, uid);
      }
    } catch (error: any) {
      const apiMessage: string = error?.error?.message || error?.message || '';
      const idsMatch = apiMessage.match(/ID\(s\):\s*([\d,\s]+)/);
      if (idsMatch) {
        const ids = idsMatch[1].split(',').map((id: string) => parseInt(id.trim())).filter((id: number) => !isNaN(id));
        const names = ids
          .map((id: number) => {
            const rule = this.RuleAppliedForDataList?.find((r: any) => r.id === id);
            return rule ? this.extractName(rule.name) : null;
          })
          .filter(Boolean)
          .join(', ');
        this._ToastrApiService.show('error', `Workflow already exists for ${names || idsMatch[1].trim()}`);
      } else {
        this._ToastrApiService.show('error', apiMessage);
      }
      return;
    }

    //GTM
    this._ApprovalManagementService.approvalSaveConfiguration('Save & Next','Workflow settings');
    this._ApprovalManagementService.approval_menu_click('Approval flow form');
    this.sendData({ form: formValue, lists: this.allCorporateUsersList });

    //GTM use
    const data = {
      form: formValue,
      lists: {
        products: this.productList,
        travellerCategories: this.travellerCategory,
        appliedOn: this.appliedOnList,
        appliedFor: this.RuleAppliedForDataList,
      }
    };
    this._ApprovalManagementService.workflow_next({ formData: data },'Save & Next')//GTM use
    this.router.navigate(['/cam/approval-management/approvalflow-form']);
  }

  optionClicked(branch: any) {
    // Toggle the checkbox state
    const newCheckedState = !this.selectedAssoicatedRuleIdMap[branch.id];

    // Create a mock event object that matches what the checkbox change expects
    const mockEvent = {
      checked: newCheckedState,
      stopPropagation: () => { } // Add empty function to prevent errors
    };

    // Call your existing checkbox handler with the toggled state
    this.onChecKboxBranch(mockEvent, branch, 'custom-mat-dropdown-parent', 'custom-autocomplete');
  };

  onCancel() {
    this._CamService.approvalWorkFlowSettingFormData = null;
    this._ApprovalManagementService.approval_workflow("Workflow Settings", 'Cancel')//GTM use
    this.router.navigate(['/cam/approval-management/approval-listing'])
  }



  appliedOnSelectionChange(AppliedOnId: any): Promise<void> {
    return new Promise((resolve, reject) => {
      this.ruleAppliedName = '';
      this.associateRuleName = []
      this.selectedAssoicatedRuleIdMap = {}
      // Find rule name from appliedOnList
      const selectedRule = this.appliedOnList?.find((rule: any) => rule.id == AppliedOnId);
      this.ruleAppliedName = selectedRule ? selectedRule.name : '';

      // Call API
      this._CamService.getRulesAppliedFor(AppliedOnId)
        .then((res) => {
          if (res.status === "Success" && res.data) {

            this.RuleAppliedForDataList = res.data;

            // Fetch workflows to filter already configured travelers
            const fetchWorkflowsPromise = this.approvalList && this.approvalList.length > 0 
              ? Promise.resolve(this.approvalList)
              : this._CamService.getApprovalManagementV1('Newest', '').then(res => res.data ?? []).catch(() => []);

            fetchWorkflowsPromise.then((existingWorkflows) => {
              if (AppliedOnId == 6 && existingWorkflows && existingWorkflows.length > 0) {
                const usedIds = new Set<number>();
                const usedNames = new Set<string>();

                existingWorkflows.forEach((item: any) => {
                  if (this.workFlowId && item.workflowId == this.workFlowId) {
                    return;
                  }

                  const isTravelerWF = 
                    item.workFlowType === 'Traveler' || 
                    item.workflowType === '6' || 
                    item.workflowType === 6;

                  if (isTravelerWF) {
                    if (item.appliedForId) {
                      if (typeof item.appliedForId === 'string') {
                        item.appliedForId.split(',').forEach((idStr: string) => {
                          const id = parseInt(idStr.trim(), 10);
                          if (!isNaN(id)) usedIds.add(id);
                        });
                      } else if (Array.isArray(item.appliedForId)) {
                        item.appliedForId.forEach((id: any) => usedIds.add(Number(id)));
                      }
                    }

                    if (item.appliedForList && typeof item.appliedForList === 'string') {
                      item.appliedForList.split(',').forEach((nameStr: string) => {
                        const clean = nameStr.trim().toLowerCase();
                        if (clean) usedNames.add(clean);
                      });
                    }
                  }
                });

                this.RuleAppliedForDataList = this.RuleAppliedForDataList.filter((traveller: any) => {
                  const id = Number(traveller.id);
                  const cleanName = this.extractName(traveller.name).toLowerCase();
                  const isUsed = usedIds.has(id) || usedNames.has(cleanName);
                  return !isUsed;
                });
              }

              // Filter data based on user input
              this.filteredAssocatedWithRule = this.appliedForID.valueChanges.pipe(
                startWith(null),
                map((value: string | null) => {
                  if (typeof value === 'string') {
                    return this._filter(value);
                  } else {
                    return this.RuleAppliedForDataList.slice();
                  }
                })
              );

              resolve(); // Resolve promise when data is successfully set
            }).catch((err) => {
              console.error("Error fetching workflows in appliedOnSelectionChange:", err);
              
              // Fallback to setting without filter in case of error
              this.filteredAssocatedWithRule = this.appliedForID.valueChanges.pipe(
                startWith(null),
                map((value: string | null) => {
                  if (typeof value === 'string') {
                    return this._filter(value);
                  } else {
                    return this.RuleAppliedForDataList.slice();
                  }
                })
              );
              resolve();
            });

          } else {
            console.warn("No valid data received for AppliedOnId:", AppliedOnId);
            resolve(); // Resolve even if no valid data to prevent hanging
          }
        })
        .catch((error) => {
          console.error("Error in appliedOnSelectionChange:", error);
          reject(error); // Reject the promise on API failure
        });
    });
  }

  onChecKboxBranch(event: any, branch: any, parentClass: string, matAutoClassRef: string) {
    this.selectedAssoicatedRuleIdMap[branch.id] = event.checked;
    // Then use it in your code:
    if (event.checked) {
      const displayName = this.getDisplayName(branch);
      if (!this.associateRuleName.includes(displayName)) {
        this.associateRuleName.push(displayName);
      }
    } else {
      const nameToRemove = this.getDisplayName(branch);
      this.associateRuleName = this.associateRuleName.filter(
        name => name !== nameToRemove
      );
    }

    const selectedAssociatedRuleId = Object.keys(this.selectedAssoicatedRuleIdMap).filter(key => this.selectedAssoicatedRuleIdMap[parseInt(key)])

    // this.workFlowSettingForm.controls['appliedForID'].setValue(selectedAssociatedRuleId.join(','));
    // this.workFlowSettingForm.controls['appliedForID'].updateValueAndValidity();

    this.workFlowSettingForm.get('appliedForID')?.setValue(selectedAssociatedRuleId.join(','));
    this.workFlowSettingForm.get('appliedForID')?.updateValueAndValidity();
    this.fruitInput.nativeElement.value = '';
    requestAnimationFrame(() => this.CustomMatAutoPosition(parentClass, matAutoClassRef));

  }

  CustomMatAutoPosition(parentClass: string, matAutoClassRef: string) {
    let parent = (document.querySelector(`.${parentClass}`) as HTMLDivElement).getBoundingClientRect();
    (document.querySelector('.cdk-overlay-connected-position-bounding-box .cdk-overlay-pane') as HTMLDivElement)?.style.setProperty('top', `${parent.top + parent.height}px`, 'important');
    // (document.querySelector(`.${matAutoClassRef}`) as HTMLDivElement).style.marginTop = `${parent.top + parent.height}px`;
  }




  getDisplayName(traveller: any): string {
    console.log("traveller", traveller)
    const fullName = traveller.name;
    const id = traveller.id;
    if (fullName.includes('(')) {
      const name = fullName.split('(')[0].trim();
      return `${name} - ${id}`
    } else {
      return fullName.trim()
    }
  }


  sendData(data: any) {
    this._CamService.approvalWorkFlowSettingFormData = data;
  }



  //chips dropdown methods 
  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      // this.associateRuleName.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.appliedForID.setValue(null);
  }

  remove(name: string): void {
    const index = this.associateRuleName.indexOf(name);
    //for travellers only
    if (name.includes('-')) {
      var id = name.split('-')[1].trim()
    }
    if (index >= 0) {
      this.associateRuleName.splice(index, 1);
      this.announcer.announce(`Removed ${name}`);
      const associateRule = this.RuleAppliedForDataList.find((rule: {
        id: string; name: string
      }) => rule.name.trim().toLowerCase() == name.trim().toLowerCase() || rule.id == id);
      if (associateRule) {
        this.selectedAssoicatedRuleIdMap[associateRule.id] = false;
        const selectedAssoRule = Object.keys(this.selectedAssoicatedRuleIdMap).filter(key => this.selectedAssoicatedRuleIdMap[parseInt(key)]);
        this.workFlowSettingForm.get('appliedForID')?.setValue(selectedAssoRule.join(','));
        this.workFlowSettingForm.get('appliedForID')?.updateValueAndValidity();
      }
    }
  }



  private _filter(value: string): any[] {
    const filterValue = value?.toLowerCase();
    const filteredData = this.RuleAppliedForDataList.filter((empDetail: { name: string; EmployeeCode: string }) => empDetail.name.toLowerCase().includes(filterValue) || empDetail.EmployeeCode?.includes(filterValue) || empDetail?.name?.split("(")[0]?.replaceAll(/\s+/g, " ")?.toLowerCase()?.includes(filterValue));
    this.noRecordFound = filteredData.length == 0;
    return filteredData
  }

  extractName(fullString: string): string {
    return fullString.split('(')[0].trim(); // Extract name before '('
  }

  extractEmail(fullString: string): string {
    const emailMatch = fullString.match(/\((.*?)\)/);
    return emailMatch ? emailMatch[1] : ''; // Extract email inside '()'
  }

  disableRightClick(event: MouseEvent): void {
    event.preventDefault();
  }

  onPasteBlocked(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent the paste action
  }

  blockInvalidCharacters(event: KeyboardEvent): void {
    // List of invalid characters that can be used for XSS, SQL injection, or path traversal
    const invalidChars = ['<', '>', '"', "'", '`', ';', '--', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}',];

    // If the pressed key is in the invalidChars array, prevent the input
    if (invalidChars.includes(event.key)) {
      event.preventDefault(); // Block the invalid character
    }
  }
  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }
}
